import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh', gap: 'var(--space-4)',
      color: 'var(--text-secondary)',
    }}>
      <h1 style={{ fontSize: 'var(--text-3xl)', color: 'var(--text-primary)' }}>404</h1>
      <p>Page not found</p>
      <Link to="/app" style={{ color: 'var(--accent-primary)' }}>← Back to dashboard</Link>
    </div>
  )
}
